/**
 * Initialization of the "Referee Education Game" Firebase project.
 * The initialization is based on the data provided in the Firebase project.
 *
 * Link to Firebase project:
 * https://console.firebase.google.com/u/2/project/referee-education-game/overview
 *
 * Components or services, which need to access firebase can simply use the exported object.
 */

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

firebase.initializeApp(
    {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
        databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL
    }
)

export const firebaseService = firebase;